// extracted by mini-css-extract-plugin
export default {"notificationRoot":"aV3fN","notificationText":"ajpWz","buttonsContainer":"hiO_e","button":"Y0Vro","mobile":"P9L1E","smallMobile":"bpsap","tablet":"dRmBX"};